<template>
  <div class="content">
    <el-form  :model="form" :disabled="true" label-width="150px">
      <el-card  shadow="never"  style="width: 70%;">
        <div slot="header" class="clearfix">
          <span style="font-size:20px;color:#181818;font-weight: 600;">主体信息</span>
          <el-tag style="margin-left:10px">
            <template>
              {{ transferOrderType(form.status) }}
            </template>
          </el-tag>
          <el-button v-show="form.status==1" style="margin-left:10px" type="primary" :disabled="false" size="mini" icon="el-icon-edit" @click="auditClick" v-hasPermi="['company:authentication:audit']">提交审核</el-button>
        </div>
        <el-form-item label="企业名称：" prop="company"  v-if="form.kycType==2">
          <el-input v-model="form.company"  placeholder="企业名称"></el-input>
        </el-form-item>
        <el-form-item label="营业执照注册号：" prop="companyNumber"  v-if="form.kycType==2">
          <el-input v-model="form.companyNumber"  placeholder="营业执照注册号"></el-input>
        </el-form-item>
        <el-form-item label="身份证姓名：" prop="realName" >
          <el-input v-model="form.realName"  placeholder="身份证姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证身份证号：" prop="idCard" >
          <el-input v-model="form.idCard"  placeholder="身份证身份证号"></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="phone" >
          <el-input v-model="form.phone"  placeholder="手机号码"></el-input>
          <div style="color:#999">此手机号为企业提现认证手机号，请确保填写的手机号码可直接联系到本人，否则认证失败。</div>
        </el-form-item>
      </el-card>
      <el-card  shadow="never"  style="width: 70%;">
        <div slot="header" class="clearfix">
          <span style="font-size:20px;color:#181818;font-weight: 600;">图片资料</span>
        </div>
        <el-row>
          <el-col :span="12">
              <el-form-item label="身份证正面：">
                <el-image  v-if="form.personHeadImg"
                  style="width: 100px; height: 100px"
                  :src="form.personHeadImg"
                  :preview-src-list="[form.personHeadImg]">
                </el-image>
                <svg-icon v-if="!form.personHeadImg" icon-class="idcard_front" class="svg-avatar-uploader-icon" />
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="身份证反面：">
                <el-image  v-if="form.personBackImg"
                  style="width: 100px; height: 100px"
                  :src="form.personBackImg"
                  :preview-src-list="[form.personBackImg]">
                </el-image>
                <svg-icon v-if="!form.personBackImg" icon-class="idcard_reverse" class="svg-avatar-uploader-icon" />
              </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
              <el-form-item label="营业执照正面："  v-if="form.kycType==2">
                <el-image  v-if="form.companyImg"
                  style="width: 100px; height: 100px"
                  :src="form.companyImg"
                  :preview-src-list="[form.companyImg]">
                </el-image>
                <svg-icon v-if="!form.companyImg" icon-class="business_license" class="svg-avatar-uploader-icon" />
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="手持身份证半身照：">
                <el-image  v-if="form.personPeopleImg"
                  style="width: 100px; height: 100px"
                  :src="form.personPeopleImg"
                  :preview-src-list="[form.personPeopleImg]">
                </el-image>
                <svg-icon v-if="!form.personPeopleImg" icon-class="idcard_hand" class="svg-avatar-uploader-icon" />
              </el-form-item>
          </el-col>
        </el-row>
      </el-card>
    </el-form>
    <!-- 弹框审核操作 -->
    <el-dialog title="企业认证审核" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" width="700px" v-dialogDrag :close-on-click-modal="false">
      <el-form :model="formData" :rules="rules" ref="formData">
        <el-form-item label="审核状态" prop="orderStatus" label-width="160px">
          <el-select v-model="formData.status" placeholder="请选择状态" style="width:350px">
            <el-option label="审核通过" value="2"></el-option>
            <el-option label="拒绝" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark" label-width="160px">
          <el-input type="textarea"  v-model="formData.remark" style="width:350px"></el-input>
        </el-form-item>
        <el-form-item style="text-align:center">
          <el-button type="primary" @click="cancelDialog">取消</el-button>
          <el-button type="success" @click="submitAudit">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { kycDetail , changeKycRecordStatus} from "@/api/api.js";
export default {
  name: "certification",
  data() {
    return {
      id:this.$route.params && this.$route.params.id,
      form:{
        kycType:'2',
        company:undefined,
        companyNumber:undefined,
        realName:undefined,
        phone:undefined,
        idCard:undefined,
        personHeadImg:undefined,
        personBackImg:undefined,
        personPeopleImg:undefined,
        companyImg:undefined
      },
      dialog:false,
      formData:{
        id:this.$route.params && this.$route.params.id,
        status:undefined,
        remark:undefined
      },
      rules:{
        status: [
            { required: true, message: '请选择审核状态', trigger: 'blur' },
          ]
      }
    };
  },
  methods: {
    transferOrderType(status) {
      let obj = {
        1: "待审核 ",
        2: "已认证",
        3: "未通过",
      };
      return obj[status];
    },
    cancelDialog(){
      this.dialog = false;
    },
    dialogClose(){
      this.dialog = false;
    },
    auditClick(){
      this.dialog = true;
    },
    //获取当前登录账号的认证信息，为认证跳转到实名认证
    userAuthInfo(){
      let params = {
        id:this.id
      }
      kycDetail(params).then(res=>{
          let data = res.data.data;
          if(!!data){
            this.form = data;
          }
      });
    },
    submitAudit(){
      this.$refs["formData"].validate(valid => {
        if (valid) {
          changeKycRecordStatus(this.formData).then(res=>{
              this.dialog = false;
              this.userAuthInfo();
          });
        }
      });
    }
  },
  mounted() {

  },
  created() {
    this.userAuthInfo();
  }
};
</script>
<style scoped lang="less">
.content{
  padding: 50px;
}

.avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width:138px;
    height: 138px;
  }
.avatar-uploader:hover {
  border-color: #409EFF;
}
.svg-avatar-uploader-icon{
  font-size: 28px;
  width: 138px;
  height: 138px;
  line-height: 138px;
  text-align: center;
}
.avatar {
  width: 138px;
  height: 138px;
  display: block;
}
</style>


